import "./styles.scoped.css";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface TrackerProps {
  children: React.ReactNode;
}

const Tracker: React.FC<TrackerProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, []);

  return <>{children}</>;
};

export default Tracker;
